const musicLinksValidationES = {
    "add": {
        "release_name": {
            "required": "El nombre del lanzamiento es obligatorio"
        },
        "ean": {
            "required": "EAN/UPC es obligatorio"
        },
        "artist_name": {
            "required": "El nombre del artista es obligatorio"
        },
        "url_part1": {
            "required": "La parte 1 de la URL es obligatoria"
        },
        "url_part2": {
            "required": "La parte 2 de la URL es obligatoria",
            "length": "La parte 2 de la URL no puede tener más de 10 caracteres",
            "duplicate": "¡Ups! Esta URL ya está asociada con otro enlace de música. Por favor, intenta con otra URL.",
            "urlAvailable": "La URL está disponible",
            "urlInvalid": "La URL es inválida"
        },
        "amazonmusic_url": {
            "required": "La URL de Amazon Music es obligatoria",
            "invalid": "Por favor, añade una URL válida de Amazon Music."
        },
        "applemusic_url": {
            "required": "La URL de Apple Music es obligatoria",
            "invalid": "Por favor, añade una URL válida de Apple Music."
        },
        "beatport_url": {
            "required": "La URL de Beatport es obligatoria",
            "invalid": "Por favor, añade una URL válida de Beatport."
        },
        "deezer_url": {
            "required": "La URL de Deezer es obligatoria",
            "invalid": "Por favor, añade una URL válida de Deezer."
        },
        "junodownload_url": {
            "required": "La URL de Junodownload es obligatoria",
            "invalid": "Por favor, añade una URL válida de Junodownload."
        },
        "soundcloud_url": {
            "required": "La URL de Soundcloud es obligatoria",
            "invalid": "Por favor, añade una URL válida de Soundcloud."
        },
        "spotify_url": {
            "required": "La URL de Spotify es obligatoria",
            "invalid": "Por favor, añade una URL válida de Spotify."
        },
        "tidal_url": {
            "required": "La URL de Tidal es obligatoria",
            "invalid": "Por favor, añade una URL válida de Tidal."
        },
        "traxsource_url": {
            "required": "La URL de Traxsource es obligatoria",
            "invalid": "Por favor, añade una URL válida de Traxsource."
        },
        "youtube_url": {
            "required": "La URL de Youtube es obligatoria",
            "invalid": "Por favor, añade una URL válida de Youtube."
        },
        "anghami_url": {
            "required": "La URL de Anghami es obligatoria",
            "invalid": "Por favor, añade una URL válida."
        },
        "bandcamp_url": {
            "required": "La URL de Bandcamp es obligatoria",
            "invalid": "Por favor, añade una URL válida."
        },
        "boomplay_url": {
            "required": "La URL de Boomplay es obligatoria",
            "invalid": "Por favor, añade una URL válida."
        },
        "iheartradio_url": {
            "required": "La URL de iHeartRadio es obligatoria",
            "invalid": "Por favor, añade una URL válida."
        },
        "jiosaavn_url": {
            "required": "La URL de JioSaavn es obligatoria",
            "invalid": "Por favor, añade una URL válida."
        },
        "sevendigital_url": {
            "required": "La URL de 7digital es obligatoria",
            "invalid": "Por favor, añade una URL válida."
        },
        "other_url": {
            "invalid": "Por favor, añade una URL válida."
        },
        "pvTrackName": {
            "required": "El nombre de la pista es obligatorio"
        },
        "pvArtistName": {
            "required": "El nombre del artista es obligatorio"
        }
    },
    "update": {
        "release_name": {
            "required": "El nombre del lanzamiento es obligatorio"
        },
        "ean": {
            "required": "EAN/UPC es obligatorio"
        },
        "artist_name": {
            "required": "El nombre del artista es obligatorio"
        },
        "url_part1": {
            "required": "La parte 1 de la URL es obligatoria"
        },
        "url_part2": {
            "required": "La parte 2 de la URL es obligatoria",
            "length": "La parte 2 de la URL no puede tener más de 10 caracteres",
            "duplicate": "¡Ups! Esta URL ya está asociada con otro enlace de música. Por favor, intenta con otra URL.",
            "urlAvailable": "La URL está disponible",
            "urlInvalid": "La URL es inválida"
        },
        "amazonmusic_url": {
            "required": "La URL de Amazon Music es obligatoria",
            "invalid": "Por favor, añade una URL válida de Amazon Music."
        },
        "applemusic_url": {
            "required": "La URL de Apple Music es obligatoria",
            "invalid": "Por favor, añade una URL válida de Apple Music."
        },
        "beatport_url": {
            "required": "La URL de Beatport es obligatoria",
            "invalid": "Por favor, añade una URL válida de Beatport."
        },
        "deezer_url": {
            "required": "La URL de Deezer es obligatoria",
            "invalid": "Por favor, añade una URL válida de Deezer."
        },
        "junodownload_url": {
            "required": "La URL de Junodownload es obligatoria",
            "invalid": "Por favor, añade una URL válida de Junodownload."
        },
        "soundcloud_url": {
            "required": "La URL de Soundcloud es obligatoria",
            "invalid": "Por favor, añade una URL válida de Soundcloud."
        },
        "spotify_url": {
            "required": "La URL de Spotify es obligatoria",
            "invalid": "Por favor, añade una URL válida de Spotify."
        },
        "tidal_url": {
            "required": "La URL de Tidal es obligatoria",
            "invalid": "Por favor, añade una URL válida de Tidal."
        },
        "traxsource_url": {
            "required": "La URL de Traxsource es obligatoria",
            "invalid": "Por favor, añade una URL válida de Traxsource."
        },
        "youtube_url": {
            "required": "La URL de Youtube es obligatoria",
            "invalid": "Por favor, añade una URL válida de Youtube."
        },
        "anghami_url": {
            "required": "La URL de Anghami es obligatoria",
            "invalid": "Por favor, añade una URL válida."
        },
        "bandcamp_url": {
            "required": "La URL de Bandcamp es obligatoria",
            "invalid": "Por favor, añade una URL válida."
        },
        "boomplay_url": {
            "required": "La URL de Boomplay es obligatoria",
            "invalid": "Por favor, añade una URL válida."
        },
        "iheartradio_url": {
            "required": "La URL de iHeartRadio es obligatoria",
            "invalid": "Por favor, añade una URL válida."
        },
        "jiosaavn_url": {
            "required": "La URL de JioSaavn es obligatoria",
            "invalid": "Por favor, añade una URL válida."
        },
        "sevendigital_url": {
            "required": "La URL de 7digital es obligatoria",
            "invalid": "Por favor, añade una URL válida."
        },
        "other_url": {
            "invalid": "Por favor, añade una URL válida."
        },
        "pvTrackName": {
            "required": "El nombre de la pista es obligatorio"
        },
        "pvArtistName": {
            "required": "El nombre del artista es obligatorio"
        }
    }
};

export default musicLinksValidationES;